import {Dispatch, SetStateAction, useEffect} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../components/button';
import InputField from '../../../../../components/simpleInput';
import {useAutoFocus} from '../../../../../utilities/hooks/useAutoFocus/useAutoFocus';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setNationalCardId: Dispatch<SetStateAction<string>>;
  nationalCardId: string;
  phoneNumber: string;
  onSubmit: () => void;
  isLoading: boolean;
}

const GetNationalCardIdBottomSheet = ({
  isOpen,
  setIsOpen,
  setNationalCardId,
  nationalCardId,
  phoneNumber,
  onSubmit,
  isLoading,
}: IProps) => {
  const inputRef = useAutoFocus(isOpen);

  return (
    <BottomSheet
      onDismiss={() => setIsOpen(false)}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 px-6 py-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-5 left-5"
          onClick={() => setIsOpen(false)}
        />

        <div className="flex flex-col items-center justify-center gap-2">
          <IconNameInfoCircle />
          <p className="flex justify-center mb-0 text-lg font-medium text-gray-950">
            تکمیل اطلاعات
          </p>
        </div>

        <span className="px-3 text-gray-700 text-md">
          لطفا کد ملی صاحب شماره{' '}
          <span className="font-semibold ">{phoneNumber}</span> را وارد کنید.
        </span>

        <div className="px-3">
          <InputField
            tabIndex={-1}
            label="کد ملی"
            name="price"
            ref={inputRef}
            type="number"
            inputMode="numeric"
            labelClassName=" -mt-2"
            placeholder="کد ملی صاحب شماره را وارد کنید"
            required
            disabled={isLoading}
            value={nationalCardId}
            onValueChange={(value: string) => {
              if (value?.length > 10) return;
              setNationalCardId(value);
            }}
          />
        </div>

        <div className="flex items-center justify-between w-full px-3">
          <div className="flex justify-end w-full">
            <Button
              className="flex items-center w-full gap-2 text-white border-none outline-none bg-farm-shop-500"
              onClick={onSubmit}
              disabled={!iSNationalCodeValid(nationalCardId)}
              isLoading={isLoading}
            >
              {'ثبت'}
            </Button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default GetNationalCardIdBottomSheet;

export const iSNationalCodeValid = (
  NC: string | number | undefined,
): boolean => {
  let NCV = NC;
  if (!NCV) return false;
  if (typeof NCV === 'number') NCV = NCV?.toString();
  if (NCV?.length === 10) return true;
  return false;
};

export const IconNameInfoCircle = ({
  className = 'w-7 h-7 text-farm-shop-600',
  fill = '#518A15',
}: {
  className?: string;
  fill?: string;
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 0C11.7657 0 8.93074 0.86 6.51874 2.472C4.10674 4.084 2.22674 6.374 1.11674 9.054C0.00674188 11.734 -0.284258 14.683 0.281742 17.528C0.847742 20.373 2.24474 22.986 4.29574 25.038C6.34674 27.089 8.96074 28.486 11.8057 29.052C14.6507 29.618 17.5997 29.327 20.2797 28.217C22.9597 27.107 25.2507 25.227 26.8617 22.815C28.4727 20.403 29.3337 17.567 29.3337 14.667C29.3297 10.778 27.7827 7.05 25.0337 4.301C22.2847 1.552 18.5557 0.00500005 14.6677 0.00100005L14.6667 0ZM14.6667 27.077C12.2117 27.077 9.81274 26.349 7.77174 24.986C5.73074 23.623 4.13974 21.684 3.20074 19.416C2.26174 17.148 2.01574 14.653 2.49474 12.246C2.97374 9.839 4.15574 7.627 5.89074 5.892C7.62574 4.157 9.83774 2.974 12.2447 2.496C14.6517 2.017 17.1477 2.263 19.4147 3.202C21.6817 4.141 23.6207 5.732 24.9847 7.773C26.3487 9.814 27.0757 12.213 27.0757 14.668C27.0717 17.958 25.7637 21.113 23.4367 23.439C21.1097 25.765 17.9557 27.074 14.6657 27.078L14.6667 27.077ZM13.5387 15.795V7.897C13.5387 7.598 13.6577 7.311 13.8697 7.099C14.0817 6.887 14.3687 6.769 14.6677 6.769C14.9667 6.769 15.2537 6.888 15.4657 7.099C15.6777 7.31 15.7967 7.598 15.7967 7.897V15.795C15.7967 16.094 15.6777 16.381 15.4657 16.593C15.2537 16.805 14.9667 16.923 14.6677 16.923C14.3687 16.923 14.0817 16.804 13.8697 16.593C13.6577 16.382 13.5387 16.094 13.5387 15.795ZM16.3587 20.872C16.3587 21.207 16.2597 21.534 16.0737 21.812C15.8877 22.09 15.6237 22.307 15.3147 22.435C15.0057 22.563 14.6657 22.597 14.3367 22.531C14.0077 22.465 13.7067 22.304 13.4697 22.068C13.2327 21.831 13.0717 21.53 13.0067 21.202C12.9417 20.874 12.9747 20.533 13.1027 20.224C13.2307 19.915 13.4477 19.651 13.7257 19.465C14.0037 19.279 14.3307 19.18 14.6657 19.18C15.1147 19.18 15.5447 19.358 15.8627 19.676C16.1807 19.994 16.3587 20.423 16.3587 20.872Z"
        fill={fill}
      />
    </svg>
  );
};
